import React from "react";
import { Form, Input, Button } from "antd";
import { LoginFormModel } from "../../types/login";
import styles from "./LoginWithCredentials.module.less";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import { useNavigate } from "react-router-dom";
import {
  PAGE_EXPIRED_PASSWORD,
  PAGE_FORGOT_PASSWORD,
  PAGE_HOME,
} from "~/constants/page";
import { useLanguage } from "~/hooks/useLanguage";
import { useLoginWithCredentials } from "./hooks/useLoginWithCredentials";

interface LoginWithCredentialsProps {}

const LoginWithCredentials: React.FC<LoginWithCredentialsProps> = () => {
  const { formatMessage } = useLanguage();

  const { loginWithCredentials, loginLoading } = useLoginWithCredentials();
  const { handleSetToken, setUserCompanyInfos, setUsername } =
    useAuthenticationContext();
  const navigate = useNavigate();

  const onSubmit = async (values: LoginFormModel) => {
    const response = await loginWithCredentials(values);

    if (response.isExpiredPassword) {
      setUsername(values.username);
      navigate(PAGE_EXPIRED_PASSWORD);
      return;
    }

    if (response.data.length == 1) {
      handleSetToken(response.data[0].token);
      navigate(PAGE_HOME);
    }
    setUserCompanyInfos(response.data);
  };

  return (
    <Form
      name="basic"
      initialValues={{ remember: true }}
      onFinish={onSubmit}
      autoComplete="off"
      className={styles.w100}
    >
      <Form.Item<LoginFormModel>
        name="username"
        rules={[
          {
            required: true,
            message: formatMessage(
              "LoginWithCredentials.Error.PleaseInputEmail",
            ),
          },
        ]}
      >
        <Input
          placeholder={formatMessage("LoginWithCredentials.Label.Username")}
          autoComplete="on"
        />
      </Form.Item>

      <Form.Item<LoginFormModel>
        name="password"
        rules={[
          {
            required: true,
            message: formatMessage(
              "LoginWithCredentials.Error.PleaseInputPassword",
            ),
          },
        ]}
      >
        <Input.Password
          // style={{ width: "100%" }}
          placeholder={formatMessage("LoginWithCredentials.Label.Password")}
          autoComplete="on"
        />
      </Form.Item>

      <Form.Item label={null}>
        <Button
          type="primary"
          loading={loginLoading}
          className={styles.loginButton}
          htmlType="submit"
        >
          {formatMessage("Login.Label.Login").toUpperCase()}
        </Button>
      </Form.Item>

      <Button
        className={styles.forgottenPasswordButton}
        type="default"
        loading={loginLoading}
        onClick={() => navigate(PAGE_FORGOT_PASSWORD)}
      >
        {formatMessage("ForgotPassword.Label.ForgotPassword")}
      </Button>
    </Form>
  );
};

export default LoginWithCredentials;
